<template>
  <div class="category-content order-content">
    <div class="main-width">
      <div class="manage-center-content">
        <div class="manage-slide">
          <el-col>
            <el-menu
              :default-active="defaultActive"
              class="el-menu-vertical-demo ulsmenu"
              @select="setStatus"
              :default-openeds="defaultOpen"
            >
              <el-submenu index="1">
                <template slot="title">
                  <i class></i>订单管理
                </template>

                <el-menu-item index="1-null">
                  <template slot="title">全部订单</template>
                </el-menu-item>

                <el-menu-item index="1-5">
                  <template slot="title">已取消</template>
                </el-menu-item>

                <el-menu-item index="1-1">
                  <template slot="title">待付款</template>
                </el-menu-item>

                <el-menu-item index="1-2">
                  <template slot="title">待发货</template>
                </el-menu-item>

                <el-menu-item index="1-3">
                  <template slot="title">已发货</template>
                </el-menu-item>

                <el-menu-item index="1-4">
                  <template slot="title">已收货</template>
                </el-menu-item>

                <el-menu-item index="1-6">
                  <template slot="title">交易成功</template>
                </el-menu-item>

                <el-menu-item index="1-7">
                  <template slot="title">交易失败</template>
                </el-menu-item>
                <el-menu-item index="1-8">
                  <template slot="title">售后订单</template>
                </el-menu-item>
              </el-submenu>
            </el-menu>
          </el-col>
        </div>
        <div v-show="show">
          <div>
            <div class="shelves-filter-wrap">
              <span class="shelves-input-item">
                <label>订单编号：</label>
                <span>
                  <input type="text" placeholder="请输入子订单编号" v-model="condition.orderInfoSn" />
                </span>
              </span>
              <span class="shelves-input-item">
                <label>父订单号：</label>
                <span>
                  <input type="text" placeholder="请输入父订单号" v-model="condition.orderObjectSn" />
                </span>
              </span>
              <span class="shelves-input-item">
                <label>下单时间：</label>
                <span>
                  <el-date-picker
                    v-model="value7"
                    type="daterange"
                    align="right"
                    size="mini"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    @change="setTime"
                    :picker-options="pickerOptions2"
                  ></el-date-picker>
                </span>
              </span>
              <span class="shelves-input-item">
                <label>收件人：</label>
                <span>
                  <input type="text" placeholder="请输入收件人姓名" v-model="condition.linkMan" />
                </span>
              </span>
              <span class="shelves-input-item">
                <label>手机号：</label>
                <span>
                  <input type="text" placeholder="请输入收件人手机号码" v-model="condition.mobile" />
                </span>
              </span>
              <span class="shelves-input-item" style="margin-top: 15px;">
                <label>商品名称：</label>
                <span>
                  <input type="text" placeholder="请输入商品名称" v-model="condition.goodsName" />
                </span>
              </span>
              <span class="shelves-input-item" style="margin-top: 15px;">
                <label>自有订单号：</label>
                <span>
                  <input type="text" placeholder="请输入自有订单号" v-model="condition.ownerOrderSn" />
                </span>
              </span>
              <br />
              <span>
                <span class="shelves-filter-btn-default shelves-filter" @click="init">查询</span>
                <span class="shelves-filter-btn-default shelves-cancel" @click="clearCondition">重置</span>
                <el-button
                  :loading="loading1"
                  class="shelves-filter-btn-default shelves-dc"
                  @click="orderDetail"
                >订单导出</el-button>
                <el-button
                  :loading="loading2"
                  class="shelves-filter-btn-default shelves-dc"
                  @click="feightData"
                >运费导出</el-button>
              </span>
            </div>
            <table class="shelves-table shelvea-tables">
              <thead :class="searchBarFixed == true ? 'isFixed' :''" id="searchBar">
                <tr>
                  <th>商品信息</th>
                  <th>最终结算价</th>
                  <th>数量</th>
                  <th>是否带票</th>
                  <th>售后</th>
                  <th>状态</th>
                  <th>包裹总额</th>
                  <th>操作</th>
                </tr>
              </thead>
              <tbody class="order-tbody" v-for="item in orderList">
                <tr>
                  <td colspan="8" class="self-tbody-space"></td>
                </tr>
                <tr>
                  <td colspan="8" class="shelves-table-block-title no-select">
                    <span>订单编号：{{item.orderSn}}</span>
                    <span>下单时间：{{item.createTime}}</span>
                    <span>收货人：{{item.linkMan}}</span>
                    <span>收货人电话：{{item.mobile}}</span>
                  </td>
                </tr>
                <tr class="order-table-item" v-for="(detail, index) in item.listDetail">
                  <td class="order-table-image">
                    <div class="order-table-image-wrap">
                      <img :src="imgAddress + detail.navigateImg1" @error="error(1)" />
                      <img v-if="item.isOwns > 0" style="width: 22px;height: 22px;position: absolute;z-index: 100;top: initial;left: 0" src="../assets/img/is_owns.png" alt="">
                    </div>
                    <div style="font-size: 12px;">
                      <div style="font-size: 12px;" class="order-goods-name">{{detail.goodsName}}</div>
                      <div style="color: #999" class="order-default-font order-guige">{{detail.specName}}</div>
                      <div style="color: #999" class="order-default-font order-guige">货号：{{detail.productBn}}</div>
                      <div style="word-break: break-all;" class="order-default-font order-guige">自有订单号：{{detail.ownerOrderSn}}</div>
                      <div style="word-break: break-all;" class="order-default-font order-guige">发货时间：{{detail.deliverTime}}</div>
                    </div>
                  </td>
                  <td class="order-default-font">¥{{detail.cooperatePrice/100}}</td>
                  <td class="order-default-font">{{detail.quantity}}</td>
                  <td>
                    <template v-if="detail.isContain == 0">不开票</template>
                    <template v-if="detail.isContain == 1">开票</template>
                  </td>
                  <td class="order-toDetail" v-if="detail.status == 1||detail.status == 5||detail.status == 6||detail.status == 7">
                    <a class="cursor-pointer">无法售后</a>
                  </td>
                  <td class="order-toDetail" v-else-if="detail.applyNum == 0">
                    <router-link
                      tag="a"
                      target="_blank"
                      :to="{name: 'AfterSale', query: { detailId: detail.orderDetailId, orderId: item.orderId,status:item.listDetail[0].status}}"
                      class="font-color-orange cursor-pointer"
                    >申请售后</router-link>
                  </td>
                  <td class="order-toDetail" v-else-if="detail.applyNum < detail.quantity">
                    <router-link
                      tag="a"
                      target="_blank"
                      :to="{name: 'AfterSale', query: { detailId: detail.orderDetailId, orderId: item.orderId,status:item.listDetail[0].status}}"
                      class="font-color-orange cursor-pointer"
                    >已申请售后{{detail.applyNum}}件</router-link>
                  </td>
                  <td class="order-toDetail" v-else>
                    <a class="cursor-pointer">已售后</a>
                  </td>
                  <td>
                    <div class="font-color-orange" v-if="detail.status == 1">待付款</div>
                    <div class="font-color-orange" v-else-if="detail.status == 2">待发货</div>
                    <div class="font-color-orange" v-else-if="detail.status == 3">已发货</div>
                    <div class="font-color-orange" v-else-if="detail.status == 4">已发货</div>
                    <div class="font-color-orange" v-else-if="detail.status == 5">已取消</div>
                    <div class="font-color-orange" v-else-if="detail.status == 6">交易成功</div>
                    <div class="font-color-orange" v-else-if="detail.status == 7">交易失败</div>
                    <div class="order-item-time">{{detail.statusTime}}</div>
                  </td>
                  <td v-if="index==0" :rowspan="item.listDetail.length">
                    <div>{{item.totalCooperatePrice/100}}</div>
                    <div class="order-item-time">（含运费：¥{{item.freight/100}})</div>
                    <div v-if="item.remark != ''">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="Top Center 提示文字"
                        placement="top"
                      >
                        <div slot="content">{{item.remark}}</div>
                        <i class="el-icon-information"></i>
                      </el-tooltip>
                    </div>
                  </td>
                  <td v-if="index == 0" :rowspan="item.listDetail.length" class="order-toDetail">
                    <router-link
                      tag="a"
                      target="_blank"
                      :to="{name: 'OrderDetail', query: { orderId: item.orderId ,orderSn:item.orderSn}}"
                      class="font-color-orange cursor-pointer"
                    >查看订单</router-link>
                    <!-- <div class="order-default-font" v-if="item.refund == 1">查看售后</div> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="block">
            <el-pagination
              layout="prev, pager, next"
              @current-change="handleCurrentChange"
              :current-page.sync="condition.pageNum"
              :total="total"
              :page-size="10"
            ></el-pagination>
          </div>
        </div>
        <div v-show="!show">
          <div>
            <div class="shelves-filter-wrap">
              <span class="shelves-input-item">
                <label>售后单号：</label>
                <span>
                  <input type="text" placeholder="请输入订单编号" v-model="afsCondition.afterSn" />
                </span>
              </span>
              <span class="shelves-input-item">
                <label>订单单号：</label>
                <span>
                  <input type="text" placeholder="请输入订单编号" v-model="afsCondition.orderInfoSn" />
                </span>
              </span>
              <span class="shelves-input-item order-range-time">
                <label>订单状态：</label>
                <span>
                  <el-select v-model="afsCondition.status" placeholder="请选择">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </span>
              </span>
              <span class="shelves-input-item" style="margin-top: 15px;">
                <label>商品名称：</label>
                <span>
                  <input type="text" placeholder="请输入商品名称" v-model="afsCondition.goodsName" />
                </span>
              </span>
              <span class="shelves-input-item">
                <label>手机号码：</label>
                <span>
                  <input type="text" placeholder="请输入收件人手机号码" v-model="afsCondition.mobile" />
                </span>
              </span>
              <span class="shelves-input-item order-range-time">
                <label>下单时间：</label>
                <span>
                  <el-date-picker
                    v-model="value6"
                    type="daterange"
                    align="right"
                    placeholder="选择日期范围"
                    @change="setAfsTime"
                    :picker-options="pickerOptions2"
                  ></el-date-picker>
                </span>
              </span>
              <span class="shelves-input-item" style="margin-top: 15px;">
                <label>自有售后单：</label>
                <span>
                  <input type="text" placeholder="请输入自有售后单号" v-model="afsCondition.ownerAfterOrderSn" />
                </span>
              </span>
              <span class="shelves-input-item" style="margin-top: 15px;">
                <label>自有订单号：</label>
                <span>
                  <input type="text" placeholder="请输入自有订单号" v-model="afsCondition.ownerOrderSn" />
                </span>
              </span>
              <br />
              <span>
                <span class="shelves-filter-btn-default shelves-filter" @click="afsInit">查询</span>
                <span
                  class="shelves-filter-btn-default shelves-cancel"
                  @click="clearAfsCondition"
                >重置</span>
                <!-- <el-button
                  :loading="loading3"
                  class="shelves-filter-btn-default shelves-dc"
                  @click="safterex"
                >导出</el-button>-->
              </span>
            </div>
            <table class="shelves-table">
              <thead :class="searchBarFixed == true ? 'isFixeds' :''" id="searchBar">
                <tr>
                  <th>商品信息</th>
                  <th>退款金额</th>
                  <th>退货数量</th>
                  <th>退款理由</th>
                  <th>售后类型</th>
                  <th>售后状态</th>
                  <th>操作</th>
                </tr>
              </thead>
              <tbody class="order-tbody" v-for="item in afsList">
                <tr>
                  <td colspan="7" class="self-tbody-space"></td>
                </tr>
                <tr>
                  <td colspan="7" class="shelves-table-block-title no-select">
                    <span>售后单号：{{item.afterSn}}</span>
                    <span>订单号：{{item.orderInfoSn}}</span>
                    <span>下单时间：{{item.orderCreateTime}}</span>
                    <span v-if="item.orderStatus == 2">订单状态：待发货</span>
                    <span v-else-if="item.status == 3">订单状态：已发货</span>
                    <span v-else-if="item.status == 4">订单状态：已收货</span>
                    <span>收货人电话：{{item.mobile}}</span>
                    <span>售后时间：{{item.afterCreateTime}}</span>
                    <span>自有订单号：{{item.ownerOrderSn}}</span>
                    <span>自有售后单号：{{item.ownerAfterOrderSn}}</span>
                  </td>
                </tr>
                <tr class="order-table-item">
                  <td class="order-table-image">
                    <div class="order-table-image-wrap">
                      <img :src="imgAddress + item.goodsImage" @error="error(1)" />
                      <img v-if="item.selfStoreId > 0" style="width: 22px;height: 22px;position: absolute;z-index: 100;top: initial;left: 0" src="../assets/img/is_owns.png" alt="">
                    </div>
                    <div style="font-size: 12px;">
                      <div style="font-size: 12px;" class="order-goods-name">{{item.goodsName}}</div>
                      <div style="color: #999" class="order-default-font order-guige">{{item.specName}}</div>
                    </div>
                  </td>
                  <td class="order-default-font">
                    <div>¥{{item.refundFee/100}}</div>
                    <div class="order-item-time">（含运费：¥{{item.refundPostage/100}})</div>
                  </td>
                  <td class="order-default-font">{{item.refundAmount}}</td>
                  <td>
                    <div>{{item.applicationReason}}</div>
                  </td>
                  <td>
                    <div>{{item.refundType}}</div>
                  </td>
                  <td>
                    <div v-if="item.status == 1">待处理</div>
                    <div v-else-if="item.status == 2">平台同意</div>
                    <div v-if="item.status == 3">已完成退款</div>
                    <div v-if="item.status == 4">拒绝</div>
                  </td>
                  <td class="order-toDetail">
                    <router-link
                      tag="a"
                      target="_blank"
                      :to="{name: 'AfterSale', query: {status:item.status, id: item.afterSalesId,detailId: item.orderDetailId}}"
                      class="font-color-orange cursor-pointer"
                    >查看售后详情</router-link>
                    <br />
                    <span @click="addOwnerAfterSn(item.afterSn,item.ownerAfterOrderSn)" style="margin-right: 0;" class="font-color-orange cursor-pointer" type="text">补充自有售后单号</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="block">
            <el-pagination
              layout="prev, pager, next"
              @current-change="handleAsfCurrentChange"
              :current-page.sync="afsCondition.pageNum"
              :total="afsTotal"
              :page-size="10"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="自有售后单号" :visible.sync="dialogFormVisible">
      <el-form>
        <el-form-item label="单号" label-width="60px">
          <el-input v-model="newOwnerAfterOrderSn" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer charge-dialog-btn">
        <el-button @click="dialogFormVisible = false" style="border-color: #ffa726;color: #ffa726">取 消</el-button>
        <el-button type="primary" @click="addOwnerAfterSnFn" style="background-color: #ffa726;border-color: #ffa726">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import store from "../store/index.js";
import {
  order,
  imgAddress,
  afterSaleList,
  exportOrderDetail,
  exportFreightDataExcel,
  // exportSafterSalesForExcel,
  addOwnerAfterSn
} from "../config/interface.js";
import { toast, imageError } from "../util/tool.js";
import { fetch } from "../config/fetch.js";
import axios from "axios";
import router from "../router/index.js";

export default {
  data() {
    return {
      pickerOptions2: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      value7: "",
      condition: {
        startTime: "",
        endTime: "",
        userId: store.state.userId,
        status: 2,
        orderInfoSn: "",
        orderObjectSn: "",
        mobile: "",
        linkMan: "",
        goodsName: "",
        pageSize: 10,
        pageNum: 1,
        ownerOrderSn: null,
      },
      defaultActive: "1-2",
      options: [
        {
          label: "全部",
          value: ""
        },
        {
          label: "待发货",
          value: "2"
        },
        {
          label: "已发货",
          value: "3"
        },
        {
          label: "已收货",
          value: "4"
        }
      ],
      afsList: {},
      orderList: {},
      imgAddress: imgAddress,
      defaultOpen: ["1"],
      total: 0,
      afsTotal: 0,
      value6: "",
      show: true,
      afsCondition: {
        afterSn: "",
        endTime: "",
        goodsName: "",
        mobile: "",
        orderInfoSn: "",
        orderObjectSn: "",
        pageNum: 1,
        pageSize: 10,
        startTime: "",
        status: "",
        userId: store.state.userId,
        ownerOrderSn: null,
        ownerAfterOrderSn: null,
      },
      type: "",
      searchBarFixed: false,
      loading1: false,
      loading2: false,
      loading3: false,
      dialogFormVisible: false,
      newOwnerAfterOrderSn: null,
      newAfterSn: null,
    };
  },
  created() {
    this.type = this.$route.params.type;
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    if (this.type == "afs") {
      this.defaultActive = "1-8";
      this.show = false;
      this.condition.startTime = "";
      this.condition.endTime = "";
      this.condition.orderInfoSn = "";
      this.condition.orderObjectSn = "";
      this.condition.mobile = "";
      this.condition.linkMan = "";
      this.condition.goodsName = "";
      this.value7 = "";
      this.condition.pageNum = 1;
      this.condition.ownerOrderSn = null,
      this.afsInit();
    } else {
      this.init();
    }
  },
  methods: {
    addOwnerAfterSnFn(){
      if(!this.newOwnerAfterOrderSn){
        toast("请填写单号", 3, false);
        return fasle;
      }
      var data = {
        appId: this.$store.state.appId,
        afterSn: this.newAfterSn,
        ownerAfterOrderSn: this.newOwnerAfterOrderSn,
        userId: this.$store.state.userId,
      };
      var url = addOwnerAfterSn;
      fetch(url, data).then(res => {
        if(res.code == 10000){
          this.afsInit();
          this.dialogFormVisible = false;
        }
      });
    },
    addOwnerAfterSn(afterSn,ownerAfterOrderSn){
      this.newOwnerAfterOrderSn = ownerAfterOrderSn;
      this.newAfterSn = afterSn;
      this.dialogFormVisible = true;
    },
    error(num) {
      imageError(num, event);
    },
    init() {
      var data = this.condition;
      data.appId = this.$store.state.appId;
      var url = order;
      data.appId = this.$store.state.appId;
      fetch(url, data).then(res => {
        this.orderList = res.data.result;
        //this.total = res.data.count;
        // console.log(res.data);
        // if (this.total == 0) {
          this.total = res.data.count;
        // }
      });
    },
    orderDetail() {
      //订单详情导出
      this.loading1 = true;
      let url = exportOrderDetail;
      var params = {
        //请求数据
        endTime: this.condition.endTime, //下单的结束范围(可不传)	string
        goodsName: this.condition.goodsName, //商品名(可不传)	string
        linkMan: this.condition.linkMan, //收件人(可不传)	string
        mobile: this.condition.mobile, //手机号(可不传)	string
        orderObjectSn: this.condition.orderObjectSn, //父订单号	string
        orderInfoSn: this.condition.orderInfoSn, //子订单号(可不传)	string
        startTime: this.condition.startTime, //下单的起始范围yy-MM-dd hh:mm:ss(可不传)	string
        status: this.condition.status, //订单状态(-1查售后,0查全部状态,1代付款,2待发货,3待收货,6交易成功,7交易关闭)	number
        userId: this.condition.userId,
        ownerOrderSn: this.condition.ownerOrderSn,
        appId: this.$store.state.appId,
        bodyId: this.$store.state.bodyId,
      };
      /*this.$message({
          showClose: true,
          message: '导出中，请稍后...'
        });*/
      axios.defaults.timeout = 30000;
      let responseType = "arraybuffer"; //返回数据类型
      fetch(url, params, responseType, { timeout: 30000 })
        .then(res => {
          let fileName = res.headers["content-disposition"].substring(
            res.headers["content-disposition"].indexOf("=") + 1
          );
          /* let successCallback = this.$message({
              showClose: true,
              message: '导出成功',
              type: 'success'
            });*/
          fileDownload(res.data, fileName); //导出数据
          console.log("导出成功");
          this.loading1 = false;
        })
        .catch(function(err) {
          console.log("导出失败");
          this.loading1 = false;
        });
    },
    feightData() {
      //运费详情导出
      this.loading2 = true;
      let url = exportFreightDataExcel;
      var params = {
        //请求数据
        endTime: this.condition.endTime, //下单的结束范围(可不传)	string
        goodsName: this.condition.goodsName, //商品名(可不传)	string
        linkMan: this.condition.linkMan, //收件人(可不传)	string
        mobile: this.condition.mobile, //手机号(可不传)	string
        orderObjectSn: this.condition.orderObjectSn, //父订单号	string
        orderInfoSn: this.condition.orderInfoSn, //子订单号(可不传)	string
        startTime: this.condition.startTime, //下单的起始范围yy-MM-dd hh:mm:ss(可不传)	string
        status: this.condition.status, //订单状态(-1查售后,0查全部状态,1代付款,2待发货,3待收货,6交易成功,7交易关闭)	number
        userId: this.condition.userId,
        ownerOrderSn: this.condition.ownerOrderSn,
        appId: this.$store.state.appId,
        bodyId: this.$store.state.bodyId,
      };
      axios.defaults.timeout = 30000;
      let responseType = "arraybuffer"; //返回数据类型
      fetch(url, params, responseType)
        .then(res => {
          let fileName = res.headers["content-disposition"].substring(
            res.headers["content-disposition"].indexOf("=") + 1
          );
          fileDownload(res.data, fileName); //导出数据
          console.log("导出成功");
          this.loading2 = false;
        })
        .catch(function(err) {
          console.log("导出失败");
          this.loading2 = false;
        });
    },
    afsInit() {
      var data = this.afsCondition;
      var url = afterSaleList;
      data.appId = this.$store.state.appId;
      data.bodyId = this.$store.state.bodyId;
      fetch(url, data).then(res => {
        this.afsList = res.data.resultData;
        console.log(res.data);
        this.afsTotal = res.data.count;
        console.log(this.afsTotal);
        for (var i = 0; i < this.afsList.length; i++) {
          this.afsList[i].afterCreateTime = this.afsList[
            i
          ].afterCreateTime.substring(0, 19);
          this.afsList[i].orderCreateTime = this.afsList[
            i
          ].orderCreateTime.substring(0, 19);
        }
      });
    },
    safterex() {
      //售后详情导出
      this.loading3 = true;
      // let url = exportSafterSalesForExcel;
      var params = {
        //请求数据
        afterSn: this.afsCondition.afterSn, //	售后单号	string
        endTime: this.afsCondition.endTime, //	结束时间	string
        goodsName: this.afsCondition.goodsName, //	商品名称	string
        mobile: this.afsCondition.mobile, //	手机号	string
        orderInfoSn: this.afsCondition.orderInfoSn, //	订单号	string
        startTime: this.afsCondition.startTime, //	开始时间	string
        status: this.afsCondition.status, //	订单状态	number
        userId: this.afsCondition.userId, //		number
        ownerOrderSn: this.afsCondition.ownerOrderSn,
        ownerAfterOrderSn: this.afsCondition.ownerAfterOrderSn,
        appId: this.$store.state.appId,
        bodyId: this.$store.state.bodyId,
      };
      axios.defaults.timeout = 30000;
      let responseType = "arraybuffer"; //返回数据类型
      fetch(url, params, responseType)
        .then(res => {
          let fileName = res.headers["content-disposition"].substring(
            res.headers["content-disposition"].indexOf("=") + 1
          );
          fileDownload(res.data, fileName); //导出数据
          console.log("导出成功");
          this.loading3 = false;
        })
        .catch(function(err) {
          console.log("导出失败");
          this.loading3 = false;
        });
    },
    setStatus(val) {
      if (val == "1-8") {
        this.show = false;
        this.afsCondition.startTime = "";
        this.afsCondition.endTime = "";
        this.afsCondition.orderInfoSn = "";
        this.afsCondition.orderObjectSn = "";
        this.afsCondition.mobile = "";
        this.afsCondition.goodsName = "";
        this.afsCondition.afterSn = "";
        this.value6 = "";
        this.afsCondition.status = "";
        this.afsCondition.pageNum = 1;
        this.afsCondition.ownerOrderSn = null;
        this.afsCondition.ownerAfterOrderSn = null;
        this.afsInit();
      } else {
        this.show = true;
        this.condition.startTime = "";
        this.condition.endTime = "";
        this.condition.orderInfoSn = "";
        this.condition.orderObjectSn = "";
        this.condition.mobile = "";
        this.condition.linkMan = "";
        this.condition.goodsName = "";
        this.value7 = "";
        this.condition.pageNum = 1;
        this.total = 0;
        this.condition.status = val.substring(2);
        this.condition.ownerOrderSn = null;
        this.init();
      }
    },
    formatData(date, regexp) {
      //时间格式化
      Date.prototype.format = function(format) {
        var o = {
          "M+": this.getMonth() + 1, //month
          "d+": this.getDate(), //day
          "h+": this.getHours(), //hour
          "m+": this.getMinutes(), //minute
          "s+": this.getSeconds(), //second
          "q+": Math.floor((this.getMonth() + 3) / 3), //quarter
          S: this.getMilliseconds() //millisecond
        };

        if (/(y+)/.test(format)) {
          format = format.replace(
            RegExp.$1,
            (this.getFullYear() + "").substr(4 - RegExp.$1.length)
          );
        }

        for (var k in o) {
          if (new RegExp("(" + k + ")").test(format)) {
            format = format.replace(
              RegExp.$1,
              RegExp.$1.length == 1
                ? o[k]
                : ("00" + o[k]).substr(("" + o[k]).length)
            );
          }
        }
        return format;
      };

      // // 转换日期格式
      // str = str.replace(/-/g, "/"); // "2010/08/01";
      // // 创建日期对象
      // var date = new Date(str);
      return date.format(regexp);
    },
    setTime(val) {
      this.condition.startTime = this.formatData(val[0], "yyyy-MM-dd hh:mm:ss");
      this.condition.endTime = this.formatData(val[1], "yyyy-MM-dd hh:mm:ss");
      console.log("时间", this.condition.startTime);
    },
    setAfsTime(val) {
      this.afsCondition.startTime = this.formatData(
        val[0],
        "yyyy-MM-dd hh:mm:ss"
      );
      this.afsCondition.endTime = this.formatData(
        val[1],
        "yyyy-MM-dd hh:mm:ss"
      );
    },
    clearCondition() {
      this.condition.startTime = "";
      this.condition.endTime = "";
      this.condition.orderInfoSn = "";
      this.condition.orderObjectSn = "";
      this.condition.mobile = "";
      this.condition.linkMan = "";
      this.condition.goodsName = "";
      this.value7 = "";
      this.condition.pageNum = 1;
      this.condition.ownerOrderSn = null;
      this.init();
    },
    clearAfsCondition() {
      this.afsCondition.startTime = "";
      this.afsCondition.endTime = "";
      this.afsCondition.orderInfoSn = "";
      this.afsCondition.orderObjectSn = "";
      this.afsCondition.mobile = "";
      this.afsCondition.goodsName = "";
      this.afsCondition.afterSn = "";
      this.value6 = "";
      this.afsCondition.status = "";
      this.afsCondition.pageNum = 1;
      this.afsCondition.ownerOrderSn = null;
      this.afsCondition.ownerAfterOrderSn = null;
      this.afsInit();
    },
    handleCurrentChange(val) {
      this.condition.pageNum = val;
      this.init();
    },
    handleAsfCurrentChange(val) {
      this.afsCondition.pageNum = val;
      this.afsInit();
    },
    handleScroll() {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 155) {
        this.searchBarFixed = true;
      } else {
        this.searchBarFixed = false;
      }
      /*eleFixed.push({
          target: document.getElementsByTagName('thead')[0], // it must be a HTMLElement
          offsetTop: 210 // height from window offsetTop
        })*/
    }
  }
};
</script>
<style scoped>
.ulsmenu {
  position: fixed;
  margin-top: -2px;
  z-index: 1000;
}
.shelvea-tables tr td:nth-child(3) {
  width: 40px;
}
.order-table-item td:nth-child(3) {
  width: 96px;
}
.isFixed {
  position: fixed;
  top: 166px;
  z-index: 1000;
}
.isFixed th:nth-child(1) {
  width: 235px;
}
.isFixed th:nth-child(2) {
  width: 94px;
}
.isFixed th:nth-child(3) {
  width: 40px;
}
.isFixed th:nth-child(4) {
  width: 51px;
}
.isFixed th:nth-child(5) {
  width: 102px;
}
.isFixed th:nth-child(6) {
  width: 246px;
}
.isFixed th:nth-child(7) {
  width: 172px;
}
.isFixed th:nth-child(8) {
  width: 110px;
}
.isFixeds {
  position: fixed;
  top: 166px;
  z-index: 1000;
}
.isFixeds th:nth-child(1) {
  width: 235px;
}
.isFixeds th:nth-child(2) {
  width: 151px;
}
.isFixeds th:nth-child(3) {
  width: 96px;
}
.isFixeds th:nth-child(4) {
  width: 179px;
}
.isFixeds th:nth-child(5) {
  width: 70px;
}
.isFixeds th:nth-child(6) {
  width: 119px;
}
.isFixeds th:nth-child(7) {
  width: 200px;
}
.el-button {
  margin-right: 14px;
  margin-left: 0;
  padding: 0;
  border-radius: 0;
}
.shelves-input-item ::-webkit-input-placeholder {
  color: #bfcbd9;
  font-size: 12px;
}
.shelves-input-item {
  display: inline-block;
  width: 300px;
  height: 28px;
  margin-bottom: 20px;
  line-height: 28px;
  margin-right: 40px;
}
.shelves-input-item span {
  display: inline-block;
  width: 210px;
  height: 26px;
  line-height: 24px;
}
.shelves-input-item > span > input {
  /* border: 0;
  outline: none; */

  border: 1px solid #d9d9d9;

  width: 190px;
  height: 100%;
  padding-left: 10px;
  font-size: 12px;
}
.shelves-input-item.order-range-time .el-input.el-date-editor--daterange {
  width: 210px;
}
.charge-dialog-btn{
  text-align: center;
  display: block;
}
.charge-dialog-btn .el-button{
  padding: 10px 20px;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// Order.vue?fbb07d56